import { IfAbility } from '@efdigital/ll-addon-auth';
import { EditCoachingConfig } from '@efdigital/ll-admin-v2/components/coaching/edit-coaching-config.gts';
import { EditContext } from '@efdigital/ll-admin-v2/components/edit-context.gts';
import type { ModelFrom } from '@efdigital/ll-admin-v2/lib/type-utils';
import type CoachingConfigsConfigRoute from '@efdigital/ll-admin-v2/routes/coaching/configs/config';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import { pageTitle } from 'ember-page-title';

interface CoachingConfigsConfigSignature {
  Args: {
    model: ModelFrom<CoachingConfigsConfigRoute>;
    controller: unknown;
  };
}

const CoachingConfigsConfigTemplate: TemplateOnlyComponent<CoachingConfigsConfigSignature> =
  <template>
    {{pageTitle @model.coachingConfig.name}}
    <div class="container py-5">
      <IfAbility @ability="coaching-configs" @atLeast="viewer">
        <:if>
          <div class="mb-4">
            <LinkTo @route="coaching.configs" class="text-muted small">
              <iconify-icon inline icon="ph:caret-left" />
              Coaching Configurations
            </LinkTo>
          </div>
          <EditContext as |context|>
            <IfAbility @ability="coaching-configs" @atLeast="editor">
              <:if>
                <EditCoachingConfig
                  @coachingConfig={{@model.coachingConfig}}
                  @context={{context}}
                  @canEdit={{true}}
                />
              </:if>
              <:else>
                <EditCoachingConfig
                  @coachingConfig={{@model.coachingConfig}}
                  @context={{context}}
                  @canEdit={{false}}
                />
              </:else>
            </IfAbility>
          </EditContext>
        </:if>
        <:else>
          <div class="alert alert-warning" role="alert">
            <h4 class="alert-heading">Access Denied</h4>
            <p class="mb-0">You do not have permission to view coaching
              configurations.</p>
          </div>
        </:else>
      </IfAbility>
    </div>
  </template>;

export default CoachingConfigsConfigTemplate;
